import "../css/divProfile.css";
import MelvinPerfil from "../img/MelvinPerfil.jpg";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

const DivProfile = () => {
  const [t] = useTranslation("global");
  return (
    <div className="divProfile">
      <div className="containerProfile">
        <img src={MelvinPerfil} alt="Profile" />
        <div>
          <h3>{t("Profile.rol")}</h3>
        </div>
      </div>

      <div
        className="card-profileIcon"
        data-aos="fade-up"
        id="divIconTecnologies"
      >
        <div className="containerProfileDetails" id="containerProfileDetails">
          <h2>{t("Profile.tecnologies")}</h2>
          <div>
            <i className="ok fa-brands fa-js" data-aos="fade-left"></i>
            <i className="fa-brands fa-react" data-aos="fade-right"></i>
            <i className="fa-brands fa-vuejs" data-aos="fade-left"></i>
            <i className="fa-brands fa-node" data-aos="fade-right"></i>
          </div>

          <div>
            <i className="fa-brands fa-html5" data-aos="fade-left"></i>
            <i className="fa-brands fa-css3" data-aos="fade-right"></i>
            <i className="fa-brands fa-bootstrap" data-aos="fade-left"></i>
            <i className="fa-brands fa-figma" data-aos="fade-right"></i>
          </div>

          <div>
            <i className="fa-brands fa-git" data-aos="fade-left"></i>
            <i className="fa-brands fa-java" data-aos="fade-right"></i>
            <i className="fa-brands fa-golang" data-aos="fade-left"></i>
            <i className="fa-brands fa-hashtag" data-aos="fade-right"></i>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DivProfile;
